export default __webpack_public_path__ + "static/support-sponsor-quad-49bfa68a00884a79660929d410d0dd1b.png";